import { graphql } from 'gatsby';

import FeaturesPage from '../components/Features/FeaturesPage';

// Single page that needs to be generated manually through `gatsby-node` as it makes use of the body content
export default (props) => FeaturesPage(props);

export const query = graphql`
  query($id: String!) {
    page: sanityFeaturesPg(_id: { eq: $id }) {
      meta: _rawMeta
      heroTitle
      heroBody: _rawHeroBody
    }
  }
`;
